import React from 'react';
export function Header() {
  return <header className="bg-black/90 backdrop-blur-md border-b border-amber-900/30 py-4 md:py-5 px-5 md:px-8 sticky top-0 z-50 shadow-2xl" data-id="element-91">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0" data-id="element-92">
        <div className="text-amber-400 font-poppins font-bold text-xl md:text-2xl tracking-widest uppercase text-center" data-id="element-93">
          Libro de la Sabiduría
        </div>
        <a href="#comprar" className="bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600 text-black font-bold px-6 py-2.5 rounded-full transition-all duration-300 shadow-[0_0_15px_rgba(245,158,11,0.4)] text-sm md:text-base transform hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-94">
          Comenzar mi viaje
        </a>
      </div>
    </header>;
}